import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';

import { DnRevenueService, NotificationService, KeywordService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dn-revenue',
  templateUrl: './dn-revenue.component.html'
})
export class DnRevenueComponent implements OnInit {

  filterable = {
    from: null,
    to: null,
    source: null,
    country: null,
    reportType: 1,
    realtime: false
  };

  loading = false;
  loaded = false;
  processing = false;
  exporting = false;
  totalItems = 0;
  emptyResult = true;
  dnRevenues: any = [];
  downloadUrl = '';
  reportTypeList = { 0: "By Keyword", 1: "By Client", 2: "By Share" }
  sourceList = [];
  countryList: any = {};
  active = 0;
  selectedCountry = '';

  realtimeFlags = {'Realtime': true, 'Offline': false};
  resultName = '';

  constructor(private dnRevenueSvc: DnRevenueService,
    private keywordSvc: KeywordService,
    private notification: NotificationService,
    private route: ActivatedRoute,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 1);
    this.filterable.to = dte.toISOString().substring(0, 10);
    dte.setDate(dte.getDate() - 7);
    this.filterable.from = dte.toISOString().substring(0, 10);
    this.loadSources();
    // this.search();
  }

  search() {
    this.loadPage();
  }

  export() {
    this.exporting = true;
    let params = {
      from: formatDate(this.filterable.from, 'yyyyMMdd', 'en'),
      to: formatDate(this.filterable.to, 'yyyyMMdd', 'en'),
      source: this.filterable.source.value,
      country: this.filterable.country,
      reportType: this.filterable.reportType
    }
    this.dnRevenueSvc.export(params, this.filterable.realtime)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  changeSource(source) {
    if (source) {
      this.countryList = source.subOptions;
      var key = Object.keys(this.countryList)[0];
      var value = this.countryList[key];
      this.selectedCountry = value;
      this.filterable.country = value;
    }
  }

  changeCountry(country) {
    this.filterable.country = country;
    this.selectedCountry = country;
  }

  changeReportType(event) {
    this.loaded = false;
  }

  log(val) { console.log(val); }

  private loadSources() {
    this.keywordSvc.getSelectionSources().pipe(first()).subscribe(data => {
      this.sourceList = data.data;
      let currentSource = this.sourceList.find(it => it.name == 'PAY365');
      if(!currentSource){
        currentSource = data.data[0];
      }
      this.filterable.source =currentSource;
      this.countryList = currentSource.subOptions;
      var key = Object.keys(currentSource.subOptions)[0];
      var value = currentSource.subOptions[key];
      this.selectedCountry = value;
      this.filterable.country = value;
    });
  }

  private loadPage() {
    this.loading = true;
    this.emptyResult = false;
    this.dnRevenues = [];
    this.totalItems = 0;
    let params = {
      from: formatDate(this.filterable.from, 'yyyyMMdd', 'en'),
      to: formatDate(this.filterable.to, 'yyyyMMdd', 'en'),
      source: this.filterable.source.value,
      country: this.filterable.country,
      reportType: this.filterable.reportType
    }
    this.resultName = this.filterable.realtime ? 'Realtime' : 'Offline';
    // get page of items from api
    this.dnRevenueSvc.getAll(params, this.filterable.realtime).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.dnRevenues = data.data;
        this.totalItems = Object.keys(data.data).length;
        this.loaded = true;
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.notification.showWarning("There is no report for this DN Charge.", "Empty Result");
      }
    });
  }

}
